import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button } from "./../Controls";

const CurrentlyEmployeed: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: string) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={<h1 className="heading-main">Are you currently employed?</h1>}
      >
        <div className="form-inputs-wrapper">
          <Button
            label="Full-time"
            onClick={() => {
              handleSubmit("full-time");
            }}
            block
            anim
            active={
              loanFormContext.employment?.value === "full-time" ? true : false
            }
          />
          <Button
            label="Part-time"
            onClick={() => {
              handleSubmit("part-time");
            }}
            block
            anim
            active={
              loanFormContext.employment?.value === "part-time" ? true : false
            }
          />
          <Button
            label="Self-employeed"
            onClick={() => {
              handleSubmit("self-employeed");
            }}
            block
            anim
            active={
              loanFormContext.employment?.value === "self-employeed"
                ? true
                : false
            }
          />
          <Button
            label="No, I'm not employeed"
            onClick={() => {
              handleSubmit("not-employeed");
            }}
            block
            anim
            active={
              loanFormContext.employment?.value === "not-employeed"
                ? true
                : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export default CurrentlyEmployeed;
